import { render, staticRenderFns } from "./InitCardContract.vue?vue&type=template&id=5c4064cc"
import script from "./InitCardContract.vue?vue&type=script&lang=js"
export * from "./InitCardContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports